export default "__VITE_ASSET__104211f1__"